import React from 'react'
import './exploreposts.css'

function ExplorePosts(){
    return(<div className='explore_posts'>
    <div className='explore_posts_posts'>

</div>
</div>)
}

export default ExplorePosts